import React from 'react';
import { Tag } from 'app/components/tag';
import { isDisabled } from 'app/infrastructure/data/date';
import { userMembersAction, UserMembersActionType, UserMembersTranslation } from '../constants';
import { ListBranchItem } from '../types-store';
import { UserMembersListItemCheckbox } from './user-members-list-item-checkbox';
import { MdWarning } from 'react-icons/md';
import { Tooltip } from 'ui/common/tooltip/tooltip';
import styles from './user-members-list-item-content.scss';

interface ListItemContentProps {
  item: ListBranchItem;
  path: number[];
  checked: boolean;
  translation: UserMembersTranslation;
  addAction: (path: number[], type: UserMembersActionType, propagate: boolean) => void;
}

export const ListItemContent = ({
  item, path, checked, addAction, translation
}: ListItemContentProps) => {

  const onChange = () => {
    addAction(path, checked ? userMembersAction.deselect : userMembersAction.select, checked);
  };

  return <div className={styles.content}>
      <div className={styles.leftSide}>
        <div className={styles.leftSideColumn}>
          <div className={styles.defaultColumn}>
            <UserMembersListItemCheckbox
              id={item.id}
              checked={checked}
              onChange={onChange} />
            <span>
              {item.description}
            </span>
          </div>
        </div>
        <div className={styles.leftSideColumn}>
          {item.email}
        </div>
      </div>
      <div className={styles.rightSide}>
        {isDisabled(item?.disabled) ?
          <Tag className={styles.tag}>
            {translation.disabled}
          </Tag>
          : <div className={styles.fixedContent} />}
        {!item?.email
          ? <Tooltip title={translation.message_user_member_info} center={true}>
            <MdWarning className={styles.warningIcon} />
          </Tooltip>
          : null}
      </div>
    </div>;
};
